export default function PrivacyPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <h1 className="mb-4 text-3xl font-bold text-white">Privacy Policy</h1>
      <p className="mb-4 text-sm text-white/50">Last updated: March 2026</p>
      <div className="space-y-6 text-white/70">
        <p>Cascade ("we", "us") is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information.</p>
        <h2 className="text-xl font-semibold text-white">Information We Collect</h2>
        <p>We collect your email address, account credentials, and social media platform tokens necessary to operate the service. We also collect usage data to improve the platform.</p>
        <h2 className="text-xl font-semibold text-white">How We Use Your Information</h2>
        <p>We use your information solely to provide the Cascade service — including ingesting your TikTok content and distributing it to connected platforms on your behalf.</p>
        <h2 className="text-xl font-semibold text-white">Data Sharing</h2>
        <p>We do not sell your personal data. We share data only with third-party services necessary to operate Cascade (e.g. Supabase, social platform APIs).</p>
        <h2 className="text-xl font-semibold text-white">Data Retention</h2>
        <p>You may delete your account at any time. Upon deletion, your personal data and platform tokens are permanently removed.</p>
        <h2 className="text-xl font-semibold text-white">Contact</h2>
        <p>For privacy questions, contact us at support@pix3l.co.</p>
      </div>
    </div>
  );
}
